import { Row, Space,Button } from 'antd';
import React, {useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { getLabList } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { UpdateLabList } from '../../redux/reducers/lablistSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { errorNotify } from '../../services/toast.notification';




const addNewOnClick = () => {
    console.log("add new clicke!");
}

const editLabOnClick = (id:number) => {
    console.log(id);
}

const removeLabOnClick = (id:number) => {
    console.log(id);
}

const LabList = () => {
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(true);
    const [permission,setPermission] = useState(false);

    const columns: ColumnsType<any> = [
        {title: 'کد مرکز',dataIndex: 'prk_AndriodLab_AutoID',key: 'prk_AndriodLab_AutoID'},
        {title: 'نام',dataIndex: 'str_LabPersianName',key: 'str_LabPersianName'},
        {title: 'استان',dataIndex: 'str_StateName',key: 'str_StateName'},
        {title: 'وب سرویس',dataIndex: 'str_ServiceURL',key: 'str_ServiceURL'},
        {title: 'تلفن مستقیم',dataIndex: 'str_DirectTel',key: 'str_DirectTel'},  
        {title: '',dataIndex: 'Action',key: 'Action',render:(_,record) => (
            <Space size="middle">
                <Button type="primary" style={{backgroundColor:"orange"}} onClick={()=>editLabOnClick(record.id) } disabled={!permission} >ویرایش</Button>
                <Button type="primary" style={{backgroundColor:"red"}} onClick={()=>removeLabOnClick(record.id)} disabled={!permission}>حذف</Button>
                {/* <a>Invite {record.Str_LabPersianName}</a>
                <a>Delete</a> */}
            </Space>
        )}, 
    ];

    useEffect(()=>{

        loadLabs();
        if(myStore.auth.loginType === 'parsicuser'){
            myStore.auth.permission.map((item:any)=>{   
                if(item.pageName == 'Lab')
                    setPermission(item.isDetailAccess);
            });
        }
        else
        {
            setPermission(true);
        }
    },[])

    const loadLabs = () => {

        getLabList()
        .then((result:any) => {
            dispatch(UpdateLabList({labList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    return (
        
        <>
            <Row>
                <CustomTable columns={columns} data={myStore.labList.list} isloading={isLoading} onAddClick={addNewOnClick} permission={permission} />
            </Row>
        </>
    );
};

export default LabList